<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :batch-edit="auth('b_equipment_edit')" :view-config="auth('b_equipment_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="机台编号">
							<c-input name="equipment_code"></c-input>
						</m-search-item>
						<m-search-item label="设备ID">
							<c-input name="device_id"></c-input>
						</m-search-item>
						<m-search-item label="状态">
							<c-select name="state" multiple :options="disableEnableDic"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_equipment_edit')" v-lock="lock('b_equipment_edit')" prepend-icon="tf-add" @click="editEquipment()">创建机台</c-button>
					<c-button v-if="auth('b_equipment_export')" v-lock="lock('b_equipment_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_equipment_export')" v-lock="lock('b_equipment_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
							
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_equipment_export')" v-lock="lock('b_equipment_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_equipment_export')" v-lock="lock('b_equipment_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_equipment_edit')" v-lock="lock('b_equipment_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveEquipment">删除</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('m_custom_equipment')" prepend-icon="tf-field-config" @click="$router.push('/custom/field/equipment')">自定义字段</c-button>
				</template>
				
				<template #state="{data}">
					<c-switch v-if="auth('b_equipment_edit')" v-model="data.state" :state-value="[1, 2]" :state-text="['启用','禁用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="200"
					button-limit="4"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_equipment_edit')" v-lock="lock('b_equipment_edit')" icon="tf-edit" @click="editEquipment(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_equipment_point_view')" v-lock="lock('b_equipment_point_view')" icon="tf-detail" @click="viewPoint(data)">查看点位</c-table-button>
						<c-table-button v-if="auth('b_equipment_edit')" v-lock="lock('b_equipment_edit')" icon="tf-trash" @click="removeEquipment(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--编辑机台信息弹窗-->
			<equipment-edit ref="equipmentEdit" @resolve="$refs.view.update()"></equipment-edit>
			<!--点位查看弹窗-->
			<equipment-point-view ref="equipmentPointView"></equipment-point-view>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import equipmentEdit from "@/pages/basic/equipment_edit.vue";
	import equipmentPointView from "@/pages/basic/equipment_point_view.vue";

	export default {
		components: {equipmentEdit, equipmentPointView},
		data() {
			return {
				workType:70
			}
		},

		computed: {
			...mapState(['disableEnableDic'])
		},
		
		methods: {
			/******新建/编辑机台*******/
			editEquipment(data) {
				this.$refs.equipmentEdit.open(data);
			},

			/******机台启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/equipment/edit/state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					success: () => {
						next();
					}
				})
			},

			/******打开点位查看*******/
			viewPoint(data) {
				this.$refs.equipmentPointView.open(data);
			},

			/****批量删除机台***/
			batchRemoveEquipment(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条机台记录吗？删除后不可恢复',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/equipment/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,
									type: Mtype
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {},
				});
			},

			/******删除机台***********/
			removeEquipment(data){
				this.$confirm({
					message:'确认删除机台【'+data.equipment_code+'】？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/equipment/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',
									type: 'success'
								});
								this.$refs.view.update();
							}
						});
					},
					cancel: () => {},
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
